import
  React
from 'react';

import {
  JourneyProvider
} from '@vodacom/web-common';

import {
  isEqual
} from 'helpers';

import {
  CacheKeys,
  JavascriptTypes,
  OriginContexts
} from '../constants';

export const withScreenViewTagging = (Component) => {

  return props => {

    React.useEffect(() => {

      if (!Component.pageName) {
        return;
      }

      const queue = [];
      const frequency = 100;
      let timeout = 200 * frequency;
      let initialized = false;

      const process = () => {

        if (!initialized) {
          return;
        }

        let action;
        while ((action = queue.shift())) {
          action?.();
        }
      };

      const view = () => {

        const context = JourneyProvider.get(CacheKeys.ConfigContext, 'value');

        queue.push(() => {
          window?.utag?.view({
            page_event: 'view',
            page_name: Component.pageName,
            ...Component.tagViewData,
            ...isEqual(context, OriginContexts.VodaPay) && { header_type: 'Mini-App' }
          });
        });

        process();
      };

      const run = () => {
        window.setTimeout(() => {

          if (
            'utag' in window
            && typeof window.utag?.view === JavascriptTypes.Function
            && typeof window.utag?.link === JavascriptTypes.Function
          ) {
            initialized = true;
            timeout = 0;
            process();
          }

          timeout -= frequency;

          if (timeout > 0) {
            run();
          }
        }, frequency);
      };

      view();
      run();

    }, []);

    return (
      <Component
        {...props} />
    );
  };
};
